/**
 * PathHomeScene — Scene 1 stub (`scene-1-path-home`) used as the source
 * scene in the painted-scene transition framework test (AGE-1421).
 *
 * Mirrors HearthScene (AGE-1419) — inline asset spec, no painted art on
 * disk, walkable polygon authored in normalised coords, one edge zone
 * (south trail to the forest hollow) plus the cottage door (doorway zone)
 * back to scene-2-hearth. The point is to exercise all three transition
 * kinds out of one scene without depending on the wave-1 painted assets.
 */

import { PaintedScene, type PaintedSceneInitData } from './PaintedScene';
import type { PaintedSceneAssetSpec } from './sceneAssetSpec.schema';
import type { JourneyManifest } from './journeyManifest.schema';

export const PATH_HOME_SCENE_PHASER_KEY = 'PathHomeScene' as const;
export const PATH_HOME_SCENE_MANIFEST_KEY = 'scene-1-path-home' as const;

export class PathHomeScene extends PaintedScene {
  constructor() {
    super(PATH_HOME_SCENE_PHASER_KEY, PATH_HOME_SCENE_MANIFEST_KEY);
  }

  protected provideAssetSpec(): PaintedSceneAssetSpec | null {
    return null;
  }

  protected provideManifest(): JourneyManifest | null {
    return null;
  }

  init(data?: PaintedSceneInitData): void {
    super.init(data);
  }
}
